export enum SignUpErrors {
  INCORRECT_FULL_NAME = 'Пожалуйста, введите корректрное ФИО.',
  INCORRECT_EMAIL = 'Введите и подтвердите email.',
  INCORRECT_PHONE = 'Пожалуйста, введите корректный номер телефона.',
  INCORRECT_PASSWORD = 'Пароль должен быть длинной от 8 до 16 символов.',
  PASSWORDS_NOT_MATCH = 'Пароли не совпадают.',
  SELECT_POINTS = 'Выберите хотя бы одну точку.',
  CONSENT_NOT_ACCEPTED = 'Необходимо принять условия Политики конфиденциальности и Пользовательского соглашения.',
  NO_ERRORS = '',
}
